import { FC, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { scenarioAtom } from '../atoms';

import { Box } from '@mui/material';

import { Accordion } from 'components/shared';

import NoScenario from '../components/NoScenario';

import Baseplan from './Baseplan';
import BaseplanTotals from './BaseplanTotals';
import WorkSupply from './WorkSupply';

const BaseplanTab: FC = () => {
  const { t } = useTranslation('common');
  const scenario = useRecoilValue(scenarioAtom);
  const [refreshTotalsGraph, setRefreshTotalsGraph] = useState(false);

  if (!scenario) {
    return <NoScenario />;
  }

  return (
    <Box component="section">
      <BaseplanTotals
        refreshTotalsGraph={refreshTotalsGraph}
        setRefreshTotalsGraph={setRefreshTotalsGraph}
      />
      <Accordion summary={t('baseplan.name')}>
        <Baseplan setRefreshTotalsGraph={setRefreshTotalsGraph} />
      </Accordion>
      <Accordion summary={t('baseplan.workSupply')}>
        <WorkSupply setRefreshTotalsGraph={setRefreshTotalsGraph} />
      </Accordion>
    </Box>
  );
};

export default BaseplanTab;
